export const nfseWebhookErrorMappings2 = {
    NFSE_WEBHOOK_RPS_FIELD_NOT_FOUND: {
        code: 'NFSE_WEBHOOK_RPS_FIELD_NOT_FOUND',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Campo de configuração do RPS não encontrado. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'pt-BR',
                message: 'Campo de configuração do RPS não encontrado. Verifique as configurações de nota fiscal.',
            },
            {
                language: 'en-US',
                message: 'RPS configuration field not found. Please check the invoice settings.',
            },
            {
                language: 'es-ES',
                message: 'Campo de configuración de RPS no encontrado. Verifique la configuración de facturas.',
            },
        ],
        technicalMessage: 'DescTipoEnteGovernamental',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_SERVICE_LIST_NO_NATIONAL_BREAKDOWN: {
        code: 'NFSE_WEBHOOK_SERVICE_LIST_NO_NATIONAL_BREAKDOWN',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A lista de serviço informada não possui código nacional correspondente. Verifique o código LC116 nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'A lista de serviço informada não possui código nacional correspondente. Verifique o código LC116 nas configurações.',
            },
            {
                language: 'en-US',
                message: 'The provided service list has no corresponding national code. Please check the LC116 code in the settings.',
            },
            {
                language: 'es-ES',
                message: 'La lista de servicios informada no tiene código nacional correspondiente. Verifique el código LC116 en la configuración.',
            },
        ],
        technicalMessage: 'Lista de Serviço informada não possui desdobramento nacional',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_SERVICE_NBS_RELATION_NOT_FOUND: {
        code: 'NFSE_WEBHOOK_SERVICE_NBS_RELATION_NOT_FOUND',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A lista de serviço e o código NBS informados não possuem relacionamento entre si. Informe uma combinação válida de lista de serviço e NBS nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'A lista de serviço e o código NBS informados não possuem relacionamento entre si. Informe uma combinação válida de lista de serviço e NBS nas configurações.',
            },
            {
                language: 'en-US',
                message: 'The provided service list and NBS code are not related to each other. Enter a valid combination of service list and NBS code in the settings.',
            },
            {
                language: 'es-ES',
                message: 'La lista de servicios y el código NBS informados no están relacionados entre sí. Ingrese una combinación válida de lista de servicios y NBS en la configuración.',
            },
        ],
        technicalMessage: 'O relacionamento entre a lista de serviço e NBS informadas não existe',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_SERVICE_DESCRIPTION_INVALID: {
        code: 'NFSE_WEBHOOK_SERVICE_DESCRIPTION_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A descrição do serviço é muito curta. Use no mínimo 10 caracteres para descrever o serviço prestado.',
            },
            {
                language: 'pt-BR',
                message: 'A descrição do serviço é muito curta. Use no mínimo 10 caracteres para descrever o serviço prestado.',
            },
            {
                language: 'en-US',
                message: 'The service description is too short. Use at least 10 characters to describe the service provided.',
            },
            {
                language: 'es-ES',
                message: 'La descripción del servicio es demasiado corta. Use al menos 10 caracteres para describir el servicio prestado.',
            },
        ],
        technicalMessage: 'Discriminação do serviço inválida',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_XML_SCHEMA_INVALID: {
        code: 'NFSE_WEBHOOK_XML_SCHEMA_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O formato do arquivo enviado é incompatível com o esperado. Tente novamente.',
            },
            {
                language: 'pt-BR',
                message: 'O formato do arquivo enviado é incompatível com o esperado. Tente novamente.',
            },
            {
                language: 'en-US',
                message: 'The submitted file format is incompatible with the expected schema. Please try again.',
            },
            {
                language: 'es-ES',
                message: 'El formato del archivo enviado es incompatible con el esperado. Intente nuevamente.',
            },
        ],
        technicalMessage: 'O XML está incompatível com o esquematico XSD ABRASF',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_DUPLICATE_LOTE_NUMBER: {
        code: 'NFSE_WEBHOOK_DUPLICATE_LOTE_NUMBER',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Número do lote já existe para este prestador. Tente reemitir a nota fiscal.',
            },
            {
                language: 'pt-BR',
                message: 'Número do lote já existe para este prestador. Tente reemitir a nota fiscal.',
            },
            {
                language: 'en-US',
                message: 'Batch number already exists for this provider. Please try reissuing the invoice.',
            },
            {
                language: 'es-ES',
                message: 'El número de lote ya existe para este prestador. Intente reemitir la factura.',
            },
        ],
        technicalMessage: 'Número de Lote já existe para esse prestador',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_DUPLICATE_RPS_NUMBER: {
        code: 'NFSE_WEBHOOK_DUPLICATE_RPS_NUMBER',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Número de RPS já utilizado. Verifique a numeração nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'Número de RPS já utilizado. Verifique a numeração nas configurações.',
            },
            {
                language: 'en-US',
                message: 'RPS number already in use. Please check the numbering in the settings.',
            },
            {
                language: 'es-ES',
                message: 'Número de RPS ya utilizado. Verifique la numeración en la configuración.',
            },
        ],
        technicalMessage: 'Campo NumeroRps já existe para esse prestador',
        severity: 'error',
        critical: false,
    },
};
